import { useRef, useEffect, useState } from 'react';
import dayjs from 'dayjs';
import useCrmInteraction from 'api/hooks/useCrmInteraction';

const intervalForView = (currentView) =>
  currentView === 'Day' ? 'Daily' : currentView === 'Week' ? 'Weekly' : 'Monthly';

// The date-histogram aggregation requires both bounds together, so a preset range (only a lower
// bound in `filter`) gets an explicit upper bound of "tomorrow" - the same convention Analytics'
// own date filters use (see useAnalyticsCommonHelpers.jsx's createDateInterval).
const buildDateFilters = (activeDateInterval) => {
  const filters = [];
  const range = activeDateInterval?.filter ?? [];
  if (range[0]) {
    filters.push({ field: 'dateTime', operator: 'date_gte', value: dayjs(range[0]).startOf('day').format('YYYY-MM-DD') });
    const upperBound = range.length === 2 && range[1] ? dayjs(range[1]).add(1, 'day') : dayjs().add(1, 'day');
    filters.push({ field: 'dateTime', operator: 'date_lt', value: upperBound.format('YYYY-MM-DD') });
  }
  return filters;
};

const useCallEngagementStats = (state) => {
  const { countMode, breakdownBy, currentView, activeDateInterval } = state;
  const { getCrmInteractionDateHistogram } = useCrmInteraction();
  const [series, setSeries] = useState(null);
  const [breakdown, setBreakdown] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = useRef(null);
  fetchData.current = async (signal) => {
    setIsLoading(true);
    try {
      const result = await getCrmInteractionDateHistogram({
        signal,
        filters: buildDateFilters(activeDateInterval),
        interval: intervalForView(currentView),
        breakdownBy,
        countMode,
      });
      if (result) {
        setSeries(result.series);
        setBreakdown(result.breakdown);
      }
    } catch (error) {}
    setIsLoading(false);
  };

  useEffect(() => {
    const controller = new AbortController();
    fetchData.current(controller.signal);
    return () => controller.abort('Component unmounted.');
  }, [countMode, breakdownBy, currentView, activeDateInterval]);

  return { series, breakdown, isLoading };
};

export { buildDateFilters };
export default useCallEngagementStats;
